import { ZodError } from 'zod';

import {
  AppError,
  BadRequestError,
  ConflictError,
  ContentTooLargeError,
  ForbiddenError,
  InternalServerError,
  NotFoundError,
  UnauthorizedError,
} from '.';

export function convertError(cause: unknown, extraInfo?: { [key: string]: any }) {
  const info = {
    ...(extraInfo ?? {}),
  };

  let error: AppError;
  if (cause instanceof AppError) {
    error = cause;
    error.info = {
      ...(error.info ?? {}),
      ...info,
    };
  } else if (cause != null && typeof cause === 'object' && 'response' in cause) {
    const res = cause?.response as {
      data?: {
        err?: string;
      };
      status?: number;
      statusText?: string;
    };
    const msg = res?.data?.err ?? res?.statusText;

    switch (res?.status ?? 500) {
      case 400:
        error = new BadRequestError(msg ?? 'Bad request', { cause: res });
        break;
      case 401:
        error = new UnauthorizedError(msg ?? 'Unauthorized', { cause: res });
        break;
      case 403:
        error = new ForbiddenError(msg ?? 'Forbidden', { cause: res });
        break;
      case 404:
        error = new NotFoundError(msg ?? 'Not found', { cause: res });
        break;
      case 409:
        error = new ConflictError(msg ?? 'Conflict', { cause: res });
        break;
      case 413:
        error = new ContentTooLargeError(msg ?? 'Content too large', { cause: res });
        break;
      default:
        error = new InternalServerError(msg ?? 'Internal error', { cause: res });
    }
  } else if (cause instanceof ZodError) {
    error = new BadRequestError('Invalid data', {
      info,
      cause,
    });
  } else {
    error = new InternalServerError('Internal error', {
      info,
      cause,
    });
  }

  return error;
}
